<template>
<div class="flex-container">
  <b-card-group columns class="mt-3">
    <div v-for="(product, index) in products" :key="index" class="product-card">
        <b-card
            :img-src="product.image_url"
            img-alt="Image"
            img-top
            img-height="240px"
            img-width="320px"
            tag="article"
            style="max-width: 20rem;"
            class="mb-2"
        >
            <b-card-title>
                <router-link :to="{name: 'Product', params: { productId: product.id }}">{{product.name}}</router-link>
            </b-card-title>

            <b-card-text>
                <p>Rp. {{product.price}}</p>
                <p>stock {{product.stock}}</p>
            </b-card-text>

            <div v-if="product.stock > 0">
                <b-button variant="primary" @click="addToCart(product.id)"> <i class="fas fa-shopping-cart"></i> Add to Cart</b-button>
            </div>
            <div v-if="product.stock == 0">
                <h3>OUT OF STOCK</h3>
            </div>
        </b-card>     
    </div>
  </b-card-group>
</div>
</template>

<script>
import axios from 'axios'
import swal2 from 'sweetalert2'

export default {
    name: 'Card',
    data() {
        return {
            // url: 'http://localhost:3000'
            url: 'https://dry-savannah-57278.herokuapp.com'
        }
    },
    methods: {
        fetchProducts () {
            this.$store.dispatch('fetchProducts')
        },
        addToCart (id) {
            if(!localStorage.token){
                this.$root.$emit('bv::show::modal','modal-1')
            }
            else{
                    axios({
                        url: `${this.url}/carts/${id}`,
                        method: 'post',
                        data: {
                            amount: 1,
                        },
                        headers: {
                            token: localStorage.token
                        }
                    })
                    .then(response=>{
                        return swal2.fire({
                            title: response.data.message,
                            text: 'Do you want buy another product?',
                            showCancelButton: true,
                            icon: 'success',
                            allowOutsideClick: false,
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#d33',
                            confirmButtonText: 'Yes',
                            cancelButtonText: 'No, Checkout now'
                        })
                    })
                    .then(result=>{
                        if(!result.value) {
                            this.$router.push({name:'Cart'})
                        }
                    })
                    .catch(err=>{
                        console.log(err)
                    })
            }
        }
    },
    computed: {
        products () {
            return this.$store.state.products
        }
    },
    created() {
        this.fetchProducts()
    }
}
</script>